import { useState } from "react";
import { Input, Text, Heading, cn } from "@athena/ui";
import { Search } from "lucide-react";
import { gradient } from "@athena/ui";
import { useTranslation } from "react-i18next";

interface Course {
    id: string;
    title: string;
}

interface StepCourseProps {
    courses: Course[];
    selectedCourseId: string | null;
    onSelect: (course: Course) => void;
}

export function StepCourse({ courses, selectedCourseId, onSelect }: StepCourseProps) {
    const { t } = useTranslation();
    const [
        search,
        setSearch,
    ] = useState<string>("");

    const filtered = courses.filter((c) => c.title.toLowerCase().includes(search.toLowerCase()));

    return (
        <div className="flex flex-col gap-4">
            <div>
                <Heading level={3} className="mb-1">
                    {t("admin.lms.whichCourseAssigning")}
                </Heading>
                <Text muted size="sm">
                    {t("admin.lms.pickOneCourse")}
                </Text>
            </div>
            <div className="relative">
                <Search className="text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
                <Input
                    placeholder="Search courses..."
                    className="pl-9"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                />
            </div>
            <div className="grid grid-cols-2 gap-3">
                {filtered.map((course) => {
                    const initials = course.title
                        .split(" ")
                        .slice(0, 2)
                        .map((w) => w[0])
                        .join("")
                        .toUpperCase();
                    const isSelected = selectedCourseId === course.id;
                    return (
                        <button
                            key={course.id}
                            type="button"
                            onClick={() => onSelect(course)}
                            className={cn(
                                "border-border flex items-center gap-3 rounded-xl border p-4 text-left transition-colors",
                                isSelected ? "border-secondary bg-secondary/5" : "bg-background hover:bg-muted/50",
                            )}
                        >
                            <div
                                className={cn(
                                    "flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-linear-to-br text-xs font-bold text-white",
                                    gradient,
                                )}
                            >
                                {initials}
                            </div>
                            <div className="min-w-0">
                                <Text weight="semibold" size="sm" className="truncate">
                                    {course.title}
                                </Text>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
